import React from 'react';
import Moment from 'react-moment';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'react-router-dom';
import { number, string, bool } from 'prop-types';
import DateTime from '../DateTime/DateTime';
import { createMarkup } from '../../utils/utils';

const propTypes = {
  id: number.isRequired,
  title: string.isRequired,
  text: string.isRequired,
  its: number.isRequired,
  changeDate: bool,
  image: string,
  inNewsItem: bool,
};

const defaultProps = {
  its: 0,
  changeDate: false,
};

const NewsPromoListItem = ({ id, title, text, its, image, changeDate, inNewsItem }) => (
  <div className="news-promo-list-item">
    {/* {changeDate && (
      <h3>
        <Moment format="DD MMMM" unix>
          {its}
        </Moment>
      </h3>
    )} */}

    {image && (
      <div className="news-promo-pic">
        <LazyLoadImage className="img-fluid" src={image} alt="" />
      </div>
    )}

    {!inNewsItem && changeDate && <DateTime className="news-promo-date" timestamp={its} />}
    {!inNewsItem && !changeDate && <DateTime className="news-promo-date" timestamp={its} />}

    {inNewsItem && <DateTime className="news-promo-date" timestamp={its} />}
    <Link className="news-promo-link" to={`/news/${id}`}>
      {title}
    </Link>
    <div className="news-promo-text" dangerouslySetInnerHTML={createMarkup(text)} />
  </div>
);

NewsPromoListItem.propTypes = propTypes;
NewsPromoListItem.defaultProps = defaultProps;

export default NewsPromoListItem;
